import ApiService from "@/common/api.service";
import {
  FETCH_FLEETS,
  FETCH_FLEET,
  UPDATE_FLEET,
  CREATE_FLEET,
  RESET_FLEET,
  DELETE_FLEET
} from "./actions.type";
import {
  FETCH_FLEET_START,
  SET_FLEETS,
  SET_FLEET
} from "./mutations.type";

const state = {
  fleets: [],
  fleetsCount: 1,
  fleet: {},
  isLoading: false
};

const getters = {
  fleetsCount: state => state.fleetsCount,
  fleets: state => state.fleets,
  fleet: state => state.fleet,
  fleetIsLoading: state => state.isLoading
};

const actions = {
  [FETCH_FLEETS]({ commit }, [filteringCriteria, search]) {
    commit(FETCH_FLEET_START);
    return ApiService.filteredCollection(
      "fleet",
      filteringCriteria,
      search
    ).then(({ data }) => {
      commit(SET_FLEETS, data);
    });
  },
  [FETCH_FLEET](context, id) {
    return ApiService.get("fleet", id).then(({ data }) => {
      context.commit(SET_FLEET, data);
    });
  },
  [UPDATE_FLEET](context, payload) {
    return ApiService.put(`fleet/${payload.id}`, payload);
  },
  [CREATE_FLEET](context, payload) {
    return ApiService.post("fleet", payload);
  },
  [RESET_FLEET](context) {
    context.commit(SET_FLEET, {});
  },
  [DELETE_FLEET](context, id) {
    return ApiService.delete("fleet", id);
  }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_FLEET_START](state) {
    state.isLoading = true;
  },
  [SET_FLEETS](state, data) {
    state.fleets = data.items || [];
    state.fleetsCount = data.total || 1;
    state.isLoading = false;
  },
  [SET_FLEET](state, data) {
    state.fleet = data;
    state.isLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
